import React, { useEffect } from 'react'
import Navbar from '../HomePage/Navbar'
import Footer from '../HomePage/Footer'
import ContactSection from '../HomePage/ContactSection'
import NewsLetter from '../HomePage/NewsLetter'
import AboutSection from './AboutSection'
import HistorySection from './HistorySection'
import StatsSection from './StatsSection'
import VisionSection from './VisionSection'
import MissionSection from './MissionSection'

function AboutUsIndex() {
  // Scroll to top on component mount
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <Navbar />
      <AboutSection />
      <HistorySection />
      <StatsSection />
      <VisionSection />
      <MissionSection />
      <ContactSection />
      <NewsLetter />
      <Footer />
    </div>
  )
}

export default AboutUsIndex
